import { Box, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

import { Section } from "@jewlr/storybook/info"

const Title = styled(Typography).attrs({
  as: "h1",
  fontSize: "32px",
  fontWeight: "700",
  lineHeight: "36px",
  mb: 6,
  px: { _: 2, tablet: 0 },
})``

const SubTitle = styled(Typography).attrs({
  fontSize: "26px",
  lineHeight: "30px",
  mb: 2,
})``

const Text = styled(Typography).attrs({
  fontSize: "16px",
  letterSpacing: "-0.02em",
  lineHeight: "20px",
})``

const HelpLink = styled(Typography).attrs({
  as: "a",
  underline: true,
})``

const TitleBox = styled(Box).attrs((props) => ({
  ...props.theme.info.accessibilityInfo.titleBox,
  ...props,
}))``

const AccessibilityStatement = () => (
  <Box contain mb="100px">
    <TitleBox>
      <Title>Web Accessibility Statement</Title>
    </TitleBox>
    <Section className="mb-48">
      <SubTitle>General</SubTitle>
      <Text>
        {sl.config.site_title} is committed to providing a website experience
        accessible to all users. We are currently working on implementing
        changes in accordance with the Accessibility for Ontarians with
        Disabilities Act (AODA). Our initial work has started with remediation
        plans actively underway. By working to conform to available standards
        and guidelines, we ensure that our website services and content will be
        accessible to everyone.
      </Text>
    </Section>
    <Section className="mb-48">
      <SubTitle>Disclaimer</SubTitle>
      <Text mb={0}>
        Our measures to support accessibility and usability are ongoing, and we
        appreciate your understanding. While we strive to follow the accepted
        guidelines and standards, issues may arise in some areas of our website.
      </Text>
    </Section>
    <Section className="mb-48">
      <SubTitle>Contact Us</SubTitle>
      <Text>
        Should you encounter an accessibility issue, contact us with the
        information, and we will make every reasonable effort to update the
        content to an accessible format. If you have a question regarding our
        website accessibility, please contact customer service via email at{" "}
        <HelpLink
          href={`mailto:${sl.config.customer_service_email}`}
          rel="nofollow"
        >
          {sl.config.customer_service_email}
        </HelpLink>{" "}
        or by phone at{" "}
        <HelpLink
          href={`tel:${sl.config.customer_service_toll_free}`}
          rel="nofollow"
        >
          {sl.config.customer_service_toll_free}
        </HelpLink>
        .
      </Text>
    </Section>
  </Box>
)

export default AccessibilityStatement
